import React from 'react';
import cs from 'classnames';
import Tag from 'shared/components/atoms/Tag';
import Tooltip from 'shared/components/atoms/Tooltip/NewTooltip';
import styles from './styles';

interface Props {
  name: string;
  nameLengthLimit?: number;
  defaultTabText?: string;
  onClick?: () => void;
  onDelete?: () => void;
  hasError?: boolean;
  className?: string;
  isActive?: boolean;
  dataId?: string;
  prompt?: {
    title: string;
    text: string;
  };
}
const Tab: React.FC<Props> = ({
  name,
  nameLengthLimit = 16,
  defaultTabText = 'Tab',
  onClick,
  onDelete,
  hasError = false,
  className,
  isActive,
  dataId,
  prompt = {},
}) => {
  const truncatedName = name.length >= nameLengthLimit ? `${name.slice(0, 15)}...` : name;
  return (
    <Tooltip content={name || defaultTabText} disabled={truncatedName === name}>
      <Tag
        data-id={dataId}
        css={[styles]}
        theme="outline"
        className={cs('tab', className, {
          'tab--error': hasError,
          'tab--active': isActive,
        })}
        onClick={onClick}
        onDelete={onDelete}
        promptText={prompt.text}
        promptTitle={prompt.title}
      >
        {truncatedName || defaultTabText}
      </Tag>
    </Tooltip>
  );
};

export default Tab;
